import { Modal } from 'antd';
import 'react-image-gallery/styles/css/image-gallery.css';
import EditMoreInfo from './editMoreInfo';
import EditNormalInfo from './editNormalInfo';
import useEditAiStripModal from './useEditAiStripModal';
import './styles.scss';

export type EditAiStripModalProps = {
  visible: boolean;
  handleClickCloseButton: () => void;
  timezoneOffset?: any;
  data: any;
  originalData?: any;
  updateEditData: (data: any, isDone: boolean, type?: any) => void;
  ecgDataMap?: any;
  ecgViewerConfig?: any;
  isEditBasicInfo?: boolean;
  handleRemoveStrip?: (data: any) => void;
  couldRemoveStrip?: boolean;
};

/**
 * Hosts the modal for editing a captured AI strip, in either its basic or extended form. Renders nothing unless visible, keeps the in-progress copy of the strip in the state returned by useEditAiStripModal, and swaps between the more-info editor and the normal-info editor depending on which mode the reviewer entered.
 *
 * @param props - Modal props carrying visible, the strip data and originalData, ecgDataMap, ecgViewerConfig, timezoneOffset and the close, update and remove callbacks.
 * @returns The rendered edit modal, or false while it is hidden.
 */
const EditAiStripModal = ({
  visible,
  handleClickCloseButton,
  timezoneOffset,
  data,
  originalData,
  updateEditData,
  ecgDataMap,
  ecgViewerConfig,
  isEditBasicInfo = false,
  handleRemoveStrip,
  couldRemoveStrip = true,
}: EditAiStripModalProps) => {
  const { state, handleEnterEditMoreInfo, handleCancelEditMoreInfo, handleSaveEditMoreInfo } =
    useEditAiStripModal({ visible });

  return (
    visible && (
      <Modal
        centered
        width={993}
        closable={false}
        className="edit-ai-strip-modal"
        wrapClassName="edit-ai-strip-modal-wrapper"
        footer={null}
        title="Edit strip"
        classNames={{ header: 'sr-only' }}
        open={visible}
        destroyOnClose
      >
        <div id="edit-strip">
          {state.isEditMoreInfo ? (
            <EditMoreInfo
              data={state.transferData}
              originalData={originalData}
              ecgDataMap={ecgDataMap}
              handleClickCloseButton={handleClickCloseButton}
              handleCancelEditMoreInfo={handleCancelEditMoreInfo}
              handleSaveEditMoreInfo={handleSaveEditMoreInfo}
              timezoneOffset={timezoneOffset}
              ecgViewerConfig={ecgViewerConfig}
              couldRemoveStrip={couldRemoveStrip}
            />
          ) : (
            <EditNormalInfo
              transferData={state.transferData}
              originalData={originalData}
              data={data}
              handleClickCloseButton={handleClickCloseButton}
              updateEditData={updateEditData}
              handleEnterEditMoreInfo={handleEnterEditMoreInfo}
              isEditBasicInfo={isEditBasicInfo}
              handleRemoveStrip={handleRemoveStrip}
              couldRemoveStrip={couldRemoveStrip}
            />
          )}
        </div>
      </Modal>
    )
  );
};

export default EditAiStripModal;
